import { useQuery } from "@tanstack/react-query";
import type { InferResponseType } from "hono";
import { handleError } from "@/api/error";
import { client, useScopedMerchantClient } from "./scoped-merchant-client";

const req = client.merchant[":merchantId"].explorer["date-limits"].$get;
export type DateLimitsResponse = InferResponseType<typeof req>;

export const useDateLimits = () => {
  const scope = useScopedMerchantClient();

  return useQuery({
    queryKey: ["date-limits", scope.merchantId, scope.workspaceId],
    queryFn: async () => {
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].explorer["date-limits"].$get({
            param: scope.param,
          })
        : await client.merchant[":merchantId"].explorer["date-limits"].$get({
            param: scope.param,
          });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: !!scope.merchantId,
    staleTime: 1000 * 60 * 60, // 1 hour - date limits don't change frequently
    gcTime: 1000 * 60 * 60 * 24, // 24 hours
  });
};
